import { ElementRef, Component, OnInit } from '@angular/core';
import {ActivatedRoute, Routes, RouterModule} from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {Router} from "@angular/router"
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
import { Title }     from '@angular/platform-browser';
// import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {
  channel: any = [];
  myPlayer:any;
  playlists: any = [];
  fullScreenMode: boolean = false;
  isWoohoo: boolean = environment['isWooHoo'];
  title: any = [];
  celebrate: boolean = false;
  celebrationMessages: any = [];
  fav:boolean = false;
  unfav:boolean = false;
  watchLaterNot:boolean = false;
  unwatchLaterNot:boolean = false;
  notifications: any = [];
  confettiGunReady: boolean = true;
  confettiGunLoaded: boolean = true;
  singleChannel = environment['singleChannel'];
  singleChannelMultiPlay = environment['singleChannelMultiPlay'];
  contents: any = [];
  channelID='';
  mobilezoomLevel=1.0;
  zoomLevel=0.6;
  type = '';
  playlistID='1';
  qualName = 'HD'
  HDQual:boolean = false;
  doi = environment['doi'];
  SDQual:boolean = false;
  Isfavourite = false;
  totalEntries: any = [];
  myTimer: any;
  selectQual: boolean = false;
  vidQuality: any = [];
  video:any = [];
  siteID = environment.siteID;
  IswatchLater = false;
  delay = ms => new Promise(res => setTimeout(res, ms));
  loading = true;
  refresh = '';
  uuid: any = '';
  channelName: any;
  videoURL = '';
  subExpired:boolean = false;
  videoMeta:any = [];
  videoType = '';
  isHD = false;
  play: boolean = false;
  canChangeQuality = false;
  constructor(private titleService: Title, private elRef: ElementRef, public ngxSmartModalService: NgxSmartModalService, private route:ActivatedRoute, public http: HttpClient, private router: Router) {
  }

  ngOnInit() {
    this.checkSub();
    this.ping();
    this.getVideoData();
  }
  ngOnDestroy() {
    if (this.myTimer) {
      clearInterval(this.myTimer);
    }
  }
  zoomIn() {
    if(this.zoomLevel < 1.0) {
      this.zoomLevel = 1.0;
    }
    this.zoomLevel = this.zoomLevel + 0.1;
    if(this.mobilezoomLevel < 1.0) {
      this.mobilezoomLevel = 1.0;
    }
    this.mobilezoomLevel = this.mobilezoomLevel + 0.1;
  }
   showGif = async () => {
    await this.delay(2000);
    this.loading = false;
   }
  zoomOut() {
    if(this.zoomLevel > 1.0) {
      this.zoomLevel = 1.0;
    }
    this.zoomLevel = this.zoomLevel - 0.1;
    if(this.mobilezoomLevel > 1.0) {
      this.mobilezoomLevel = 1.0;
    }
    this.mobilezoomLevel = this.mobilezoomLevel - 0.1;
  }
  checkSub() { 
    if (window.location.href.indexOf("false") > -1) {
    this.subExpired = true;
    }
  }
  playPause() { 
    this.play = !this.play;
  }
  selectQuality() { 
    this.selectQual = !this.selectQual;
  }
  public ping() {
    this.route.params.subscribe(params2 => {
      this.uuid = params2['uuid'];
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data').set('responseType', 'text');
      let body = new HttpParams();
      this.http.get('https://api-staging.videyo.tv/stream/renderContentView?uuid='+this.uuid+'&raw=true', {
        headers: myheader
      })
      .subscribe(

        data => {
          
          this.video = data;
       this.type = this.video['contentType'];
       if(this.type == 'VIDEO') {
       this.showGif()
       }
       if(this.type == 'VIDEO') {
        this.startViewTimer()
          this.vidQuality = this.video['source']['encoded']['video'];
          if(this.video["source"]["encoded"]["video"]["360"]){
            this.videoURL = this.video["source"]["encoded"]["video"]["360"]
            this.qualName = 'SD'
            this.SDQual = true;
          }
          else if (this.video["source"]["encoded"]["video"]["720"]){
            this.videoURL = this.video["source"]["encoded"]["video"]["720"]
            this.qualName = 'HD'
            this.HDQual = true;
          }
          else { 
            this.videoURL = this.video['source']['raw']['video']['url'];
            this.qualName = 'HD'
            this.HDQual = true;
          }
          if (this.video["source"]["encoded"]["video"]["720"]){ 
            this.HDQual = true;
          }
          this.videoType = this.video['source']['raw']['video']['type'];
          // let's check and confirm we can do the hd or sd thing:
          if(this.video["source"]["encoded"]["video"]["360"] || this.video["source"]["encoded"]["video"]["240"] || this.video["source"]["encoded"]["video"]["144"] || this.video["source"]["encoded"]["video"]["720"]){
            this.canChangeQuality = true;
          }
          else{
          }
        }
        else if(this.type == "PDF") {
          this.videoURL = this.video['src'];
          this.startViewTimer()
        }
      });
        },
        error => {
        }
      );
    }
  public startViewTimer(){
    let that = this;
      this.myTimer = setInterval(function(){
        that.tickPDF()
      }, 5000);
}

public tickPDF() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data').set('responseType', 'text');
    let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/stream/incrementUnitsViewed?uuid='+this.uuid, {
      headers: myheader
    })
    .subscribe(

      data => {
      }),
      error => {
      }
    }
     public getVideoData() {
      this.route.params.subscribe(params2 => {
        this.uuid = params2['uuid'];
        const myheader = new HttpHeaders().set('Content-Type', 'application/form-data').set('responseType', 'text');
        let body = new HttpParams();
        this.http.get('https://api-staging.videyo.tv/endpoint/getContentDetails?uuid='+this.uuid, {
          headers: myheader
        })
        .subscribe(

          data => {
            this.videoMeta = data;
            this.titleService.setTitle( this.videoMeta['title'] );
            this.channelID = this.videoMeta.channelID;
            this.playlistID = this.videoMeta.playlistID;
            this.Isfavourite = this.videoMeta.isFavourite;
            this.IswatchLater = this.videoMeta.isWatchLater;
          });
          },
          error => {
          }
        );
      }
      cameraStream(chosenCamera: string) {
        this.videoURL = chosenCamera;
        const player = this.elRef.nativeElement.querySelector('video');
        player.load();
      }
  public watchSD(){
    if(this.video["source"]["encoded"]["video"]["360"]){
      this.videoURL = this.video["source"]["encoded"]["video"]["360"]
    }
    else if(this.video["source"]["encoded"]["video"]["240"]){
      this.videoURL = this.video["source"]["encoded"]["video"]["240"]
    }
    else if(this.video["source"]["encoded"]["video"]["144"]){
      this.videoURL = this.video["source"]["encoded"]["video"]["144"]
    }
    else
    {
      this.videoURL = this.video["source"]["raw"]["video"]["url"]
    }
    this.cameraStream(this.videoURL);
    this.qualName = 'SD'
  }

  public watchHD(){
    if(this.video["source"]["encoded"]["video"]["720"]){
      this.videoURL = this.video["source"]["encoded"]["video"]["720"]
    }
    else if(this.video["source"]["encoded"]["video"]["480"]){
      this.videoURL = this.video["source"]["encoded"]["video"]["480"]
    }
    else
    {
      this.videoURL = this.video["source"]["raw"]["video"]["url"]
    }
    this.cameraStream(this.videoURL);
    this.qualName = 'HD'
  }
  public favourite(contentId, playlistId) {
    this.fav = true;
    setTimeout(()=>{                           //<<<---using ()=> syntax
      this.fav = false;
 }, 3000);
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    
    this.http.get('https://api-staging.videyo.tv/endpoint/makeFavorite?siteID='+this.siteID+'&playlistID='+playlistId+'&contentId='+contentId+'&channelID='+this.channelID,{
      headers:myheader
    })
    .subscribe(
      data => {
        this.Isfavourite = !this.Isfavourite;
      },
      error => {
      }
  );
  }
  public unfavourite(contentId, playlistId) {
    this.unfav = true;
    setTimeout(()=>{                           //<<<---using ()=> syntax
      this.unfav = false;
 }, 3000);
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    
    this.http.get('https://api-staging.videyo.tv/endpoint/makeUnFavorite?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
      headers:myheader
    })
    .subscribe(
      data => {
        this.Isfavourite = !this.Isfavourite;
      },
      error => {
      }
  );
  }
  public myList(contentId, playlistId){
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  
  this.http.get('https://api-staging.videyo.tv/endpoint/addToMyList?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
    headers:myheader
  })
  .subscribe(
    data => {
    },
    error => {
    }
);
  }
  fullScreen() { 
    this.fullScreenMode = !this.fullScreenMode;
  }
  public watchLater(contentId, playlistId){
    this.watchLaterNot = true;
    setTimeout(()=>{                           //<<<---using ()=> syntax
      this.watchLaterNot = false;
 }, 3000);
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  
  this.http.get('https://api-staging.videyo.tv/endpoint/addToWatchLater?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
    headers:myheader
  })
  .subscribe(
    data => { 
   this.IswatchLater = !this.IswatchLater;
    },
    error => {  
    }
);
  }
  public unwatchLater(contentId, playlistId){
    this.unwatchLaterNot = true;
    setTimeout(()=>{                           //<<<---using ()=> syntax
      this.unwatchLaterNot = false;
 }, 3000);
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  
  this.http.get('https://api-staging.videyo.tv/endpoint/removeFromWatchLater?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
    headers:myheader
  })
  .subscribe(
    data => {
      this.IswatchLater = !this.IswatchLater;
    },
    error => {
    }
);
  }
}
